import React from "react";

import { BookingFormInputProps } from "shared/types";

import FormErrorText from "@components/UI/Form/FormErrorText";

import BookingFormDate from "./BookingFormDate";
import BookingFormTelephone from "./BookingFormTelephone";

export default function BookingFormInput({
  value,
  format,
  onChange,
  isError,
  errorType,
  errorMessageOptions,
  isPasswordField,
  name,
  dateRange,
}: BookingFormInputProps) {
  if (format === "date") {
    return (
      <BookingFormDate
        onChange={onChange}
        value={value}
        isError={isError}
        errorType={errorType}
        name={name}
        dateRange={dateRange}
      />
    );
  }

  if (format === "country_calling_code") {
    return (
      <BookingFormTelephone
        value={value}
        onChange={onChange}
        isError={isError}
        errorType={errorType}
        name={name}
      />
    );
  }

  return (
    <>
      <input
        placeholder=" "
        value={value}
        type={isPasswordField ? "password" : "text"}
        onChange={(e) => onChange(e.target.value)}
        className="form-text-input-field"
      />

      {isError && (
        <div className="form-text-input-error">
          <FormErrorText
            error={errorType}
            errorMessageOptions={errorMessageOptions}
          />
        </div>
      )}
    </>
  );
}
